import { PRODUCT_TYPE_E_COUPON } from '~/pages/e-coupon/constants';
import type { OAISchema } from '~/types/openapi';

import ECouponProductDisplayItem from './ECouponProductDisplayItem';
import ProductDisplayItem from './ProductDisplayItem';

interface Props {
  products: OAISchema['MarketSelectProductResponseV2'][];
  eventOption?: Record<string, unknown>;
}

const ProductListDisplay = ({ products, eventOption = {} }: Props) => {
  return (
    <>
      {products.slice(0, 3).map((product) => {
        if (product.productType === PRODUCT_TYPE_E_COUPON) {
          return (
            <ECouponProductDisplayItem
              product={product}
              key={product.offerId}
              eventOption={eventOption}
              reverseCouponDiscountedPrice
            />
          );
        }

        return (
          <ProductDisplayItem
            product={product}
            key={product.offerId}
            eventOption={eventOption}
            reverseCouponDiscountedPrice
          />
        );
      })}
    </>
  );
};

export default ProductListDisplay;
